import React from 'react';
import * as cssVariable from 'cssVariables';

import svgIcon from 'components/hoc/svgIcon';

const svg = (
  <svg viewBox="0 0 26 26" width="26" height="26">
    <path
      fill={cssVariable.blue500}
      d="m34.2829327 43.1776695h-5.1578947c-.631579 0-1.2105264-.5263158-1.2105264-1.2105263v-7.4736842h-7.5263158c-.6315789 0-1.2105263-.5263158-1.2105263-1.2105263v-5.1578947c0-.631579.5263158-1.2105264 1.2105263-1.2105264h7.5263158v-7.5263158c0-.6315789.5263158-1.2105263 1.2105264-1.2105263h5.1578947c.6315789 0 1.2105263.5263158 1.2105263 1.2105263v7.5263158h7.4736842c.631579 0 1.2105263.5263158 1.2105263 1.2105264v5.1578947c0 .6315789-.5263158 1.2105263-1.2105263 1.2105263h-7.5263158v7.5263158c0 .6315789-.5263158 1.1578947-1.1578947 1.1578947zm-4.9806001-1.7857143h4.7001348v-8.3389487h8.3894878v-4.7001348h-8.3894878v-8.3894879h-4.7001348v8.3894879h-8.3389488v4.7001348h8.3894879v8.3389487z"
      transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.970981 -32.41429)"
    />
  </svg>
);

export default svgIcon(svg);
